export const acceptedFileMimeTypes = Object.keys({
  // Word documents
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    ".docx",
  "application/msword": ".doc",
  // PDF documents
  "application/pdf": ".pdf",
  // Excel spreadsheets
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
  "application/vnd.ms-excel": ".xls",
  // PowerPoint presentations
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    ".pptx",
  "application/vnd.ms-powerpoint": ".ppt",
  // Images
  "image/jpeg": ".jpg",
  "image/png": ".png",
  "image/gif": ".gif",
  "image/tiff": ".tiff",
  // Text files
  "text/plain": ".txt",
  "text/csv": ".csv",
  // Archives
  "application/zip": ".zip",
  "application/x-rar-compressed": ".rar",
  "application/x-7z-compressed": ".7z",
  //Video files
  "video/mp4": ".mp4",
  "video/quicktime": ".mov",
  "video/x-msvideo": ".avi",
  "video/x-matroska": ".mkv",
  "video/webm": ".webm",
  "video/3gpp": ".3gp",
  "video/x-ms-wmv": ".wmv",
  // Use the extension to avoid accepting every application/octet-stream file.
  ".g64x": ".g64x",
} as const);

export const acceptedFileMimeTypesDocumentOnly = Object.keys({
  // Word documents
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    ".docx",
  "application/msword": ".doc",
} as const);

export const acceptedFileMimeTypesImageOnly = Object.keys({
  "image/jpeg": ".jpg",
  "image/png": ".png",
  "image/gif": ".gif",
  "image/tiff": ".tiff",
} as const);

export const MATTER_INCIDENT_REPORT_SENTIMENT_OPTIONS = [
  "Favorable",
  "Unfavorable",
  "Inconclusive",
] as const;
